import { useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import UserCardModal from "../../../../../components/modals/UserCardModal";

export default function People({ people }) {
  const [user, setUser] = useState("");
  const [open, setOpen] = useState(false);
  const cancelButtonRef = useRef(null);
  const history = useHistory();

  const viewMore = () => {
    history.push("people");
  };

  const QuestionCard = () => {
    return (
      <div className="w-full h-64 border rounded-md bg-gray-50">
        <div className="flex flex-col justify-center p-5">
          <div className="text-2xl font-bold">Found anyone you know?</div>
          <div className="text-lg mt-2">
            Click on view more to see more friends.
          </div>
          <div className="mt-5">
            <button
              className="bg-green-800 py-2 px-4 rounded text-white"
              onClick={() => viewMore()}
            >
              View More
            </button>
          </div>
        </div>
      </div>
    );
  };

  const ImageCard = ({ item }) => {
    return (
      <div onClick={() => handleItemView(item)} className="cursor-pointer">
        <div className="relative">
          <img
            src={item.profileImage}
            alt="people"
            className="w-full h-64 rounded-md"
          />
          <div class="absolute bottom-20 left-0 right-0 px-4 py-2 bg-gray-800 opacity-70">
            <h3 class="text-xl text-white font-bold text-center">
              {item.firstName}
            </h3>
          </div>
        </div>
      </div>
    );
  };

  const handleItemView = (item) => {
    setUser(item);
    setOpen(true);
  };

  return (
    <div className="md:h-full py-10">
      <div className="flex flex-col items-center">
        <div className="text-2xl font-bold">People</div>
        <div className="text-xl">People you might know</div>
      </div>
      <div className="flex mt-10">
        <div className="rounded-md">
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-10 md:gap-10 lg:gap-10 mt-3">
            <QuestionCard />
            {people.map((item, index) => {
              return <ImageCard item={item} key={index} />;
            })}
          </div>
        </div>
      </div>
      <UserCardModal
        user={user}
        open={open}
        setOpen={setOpen}
        cancelButtonRef={cancelButtonRef}
      />
      {/* </div> */}
    </div>
  );
}
